import React, { useEffect, useState } from 'react'
import { Modal, Form, Button, FormGroup } from 'react-bootstrap'
import Field from '../../../utils/Form/Widgets/Field'
import axios from 'axios'
import Select, { ActionMeta, MultiValue, SingleValue } from 'react-select'
import { CompanyListItem } from '../../charts/core/_models'
import Textarea from '../../../utils/Form/Widgets/Textarea'

type SendDataModalProps = {
  show: boolean
  dataRequestId: string
  onHide: () => void
  refreshFunction?: Function
}

const SendDataRequestModal: React.FC<SendDataModalProps> = ({
  show,
  dataRequestId,
  onHide,
  refreshFunction,
}) => {
  const [formData, setFormData] = useState({
    companyMeters: [],
    mailTo: '',
    mailBody: '',
  })
  let [selectedMeters, setSelectedMeters] = useState<MultiValue<CompanyListItem>>([])
  const [meterOptions, setMeterOptions] = useState<{ label: string; value: string }[]>([])

  const getMeters = async () => {
    try {
      if (dataRequestId) {
        const url = `/data_requests/getMetersForDataRequest/` + dataRequestId
        axios.get(url).then((response) => {
          const options = response.data.data.map((meter: any) => ({
            label: meter,
            value: meter,
          }))
          console.log('options:', options)
          setMeterOptions(options)
          setSelectedMeters(options)
          setFormData(
            (prevData) =>
              ({
                ...prevData,
                companyMeters: options,
              } as typeof prevData)
          )
        })
      }
    } catch (error) {
      console.error('Error fetching company sites:', error)
    }
  }

  useEffect(() => {
    getMeters()
    setFormData((prevData) => ({
      ...prevData,
      mailBody:
        'Hi, Are you able to send across copy of invoices for the consumption periods below please? Date Period: 2024',
    }))
  }, [dataRequestId, show])

  const handleInputChange = (
    newValue: MultiValue<CompanyListItem>,
    actionMeta: ActionMeta<CompanyListItem>
  ) => {
    setSelectedMeters(newValue)
    const selectedMeterValues = Array.isArray(newValue)
      ? newValue.map((option) => option.value)
      : []

    if (selectedMeterValues.length > 0) {
      setFormData(
        (prevData) =>
          ({
            ...prevData,
            companyMeters: selectedMeterValues,
          } as typeof prevData)
      )
    }
  }

  const handleMailToInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target
    setFormData((prevData) => ({
      ...prevData,
      mailTo: value,
    }))
  }

  const handleMailBodyInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target
    setFormData((prevData) => ({
      ...prevData,
      mailBody: value,
    }))
  }

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    try {
      const response = await axios.post('/data_requests/sendDataRequestMail', {
        data_request_id: dataRequestId,
        company_meters: formData.companyMeters,
        mail_to: formData.mailTo,
        mail_body: formData.mailBody,
      })
      console.log('response', response)
      if (response.status === 200) {
        console.log('Email sent successfully.')
        onHide()
      } else {
        console.log('API error:', response)
      }
    } catch (error) {
      console.log('An error occurred:', error)
    }
  }

  return (
    <Modal
      id='kt_modal_create_company'
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered'
      size='lg'
      show={show}
      backdrop={true}
      onHide={onHide}
    >
      <form
        onSubmit={(event) => {
          handleSubmit(event).then((response) => {
            if (refreshFunction) {
              refreshFunction(response)
            }
          })
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Send Data Request Mail</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormGroup>
            <FormGroup>
              <p>Select Meters</p>
              <Select
                name='company_meters'
                defaultValue={selectedMeters}
                onChange={handleInputChange}
                options={meterOptions}
                isMulti={true}
                value={selectedMeters}
                required={true}
              />
            </FormGroup>
            <FormGroup>
              <Field
                title='Mail To'
                className='form-control'
                type='text'
                name='mail_to'
                onInput={handleMailToInputChange}
                placeholder='test@energyimpact.com'
                required={true}
              />
            </FormGroup>
            <FormGroup>
              <Textarea
                title='Mail Body'
                className='form-control'
                type='textarea'
                name='mail_body'
                onInput={handleMailBodyInputChange}
                defaultValue={
                  'Hi,Are you able to send across copy of invoices for the consumption periods below please? Date Period: 2024'
                }
                required={true}
              />
            </FormGroup>
          </FormGroup>
        </Modal.Body>
        <Modal.Footer className='justify-content-end'>
          <button type='submit' className='btn btn-primary btn-sm'>
            Send Mail
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  )
}

export default SendDataRequestModal
